import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AddExternalPartiesIcon = (props: IconProps) => (
  <Icon w="27px" h="24px" viewBox="0 0 27 24" {...props} fill="none">
    <mask
      id="mask0_3481_74037"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.8704 10.2303C23.3983 10.3413 22.906 10.4 22.4 10.4C18.8654 10.4 16 7.53462 16 4C16 2.90763 16.2737 1.87918 16.7562 0.979474C15.2979 0.34924 13.6897 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 11.3987 23.9558 10.8078 23.8704 10.2303Z"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_3481_74037)">
      <path
        d="M16.7275 0.96713C15.2768 0.344681 13.6787 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 11.492 23.9684 10.9914 23.9072 10.5"
        stroke="#007AFF"
        strokeWidth="2"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.60002 6H16.2C16.86 6 17.4 6.54 17.4 7.2V10.2H16.2V8.4L11.4 11.4L6.60002 8.4V14.4H12.6V15.6H6.60002C5.94002 15.6 5.40002 15.06 5.40002 14.4L5.40602 7.2C5.40602 6.54 5.94002 6 6.60002 6ZM6.60002 7.2L11.4 10.2L16.2 7.2H6.60002Z"
      fill="#007AFF"
    />
    <path
      d="M15.9001 14.7C16.8076 14.7 17.5501 13.9575 17.5501 13.05C17.5501 12.1425 16.8076 11.4 15.9001 11.4C14.9926 11.4 14.2501 12.1425 14.2501 13.05C14.2501 13.9575 14.9926 14.7 15.9001 14.7ZM19.2001 17.5297C19.2001 16.8615 18.8041 16.2675 18.1936 16.0035C17.4923 15.6982 16.7168 15.525 15.9001 15.525C15.0833 15.525 14.3078 15.6982 13.6066 16.0035C12.9961 16.2675 12.6001 16.8615 12.6001 17.5297V18H19.2001V17.5297Z"
      fill="#007AFF"
    />
    <circle cx="22.4" cy="4" r="4" fill="#E94545" />
  </Icon>
);

export default memo(AddExternalPartiesIcon);
